export default "__VITE_ASSET__dcd06b73__"